<template>
  <div class="select_parts_color">
    <nav class="select_parts_container">
      <li
        v-for="{ id, name, filename } in item_list"
        :key="id"
        class="parts_color__item"
        :class="{disabled: isSelected(id)}"
      >
        <button class="parts_item__btn" :disabled="isSelected(id)" @click="setAttrib(id, $event)">
          <div class="color_chip__container">
            <img
              class="color_chip"
              :src="`item_image/parts/${filename}`"
              :alt="id"
              :title="name"
            />
          </div>
          <div class="color_name" v-html="insertWbr(name)" />
        </button>
      </li>
    </nav>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
const seg = new Intl.Segmenter('ja-JP', { granularity: 'word' })

export default {
  name: "SelectPartsColor",
  props: {
    item_list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters("simulator", ["editing_productType", "editing_parts"])
  },
  methods: {
    ...mapMutations(['setModal']),
    ...mapActions('simulator', ['justUpdateItemInfo', 'updateItemInfo']),
    isSelected (id) {
      return id === (this.editing_parts.bottom_rail || this.editing_parts)
    },
    insertWbr (str) {
      return Array.from(seg.segment(str)).map(({ segment }) => segment ).join('<wbr>')
    },
    setAttrib (id, { target }) {
      if (this.editing_productType.startsWith('AB-')) {
        console.log({ before: this.editing_parts })
        // 'AB-'で始まる製品タイプのみ別処理
        const parts = Object.entries(this.editing_parts).reduce((parts, [key, val]) => {
          parts[key] = val.match(/FT-/) ? id : val
          return parts
        }, {})
        console.log({ id, parts })
        this.updateItemInfo({parts})
      } else {
        this.updateItemInfo({parts: id})
      }
      // this.justUpdateItemInfo({parts: id})
      let clearId = null
      new Promise ((resolve) => {
        target.parentElement.addEventListener('transitionend', () => {
          resolve()
        }, { once: true })
        clearId = setTimeout(() => resolve(), 100)
      }).then(() => {
        clearId && clearTimeout(clearId)
        this.setModal('')
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.select_parts_color {
  height: 100%;
  .select_parts_container {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    margin: 0 auto;
    width: calc(332 / 349 * 100%);
    min-height: 100%;
    .parts_color__item {
      position: relative;
      list-style: none;
      flex: 0 0 auto;
      flex-basis: calc(146 / 332 * 100%);
      margin: calc(10 / 332 * 100%);
      &.disabled {
        .parts_item__btn {
          top: -4px;
          left: -4px;
          width: calc(100% + 8px);
          height: calc(100% + 8px);
          padding: 0 calc(8 / 146 * 100%);
          border: 4px solid #000;
        }
      }
      &::before {
        display: block;
        content: '';
        padding-top: calc(30 / 142 * 100%);
      }
      .parts_item__btn {
        position: absolute;
        display: flex;
        align-items: center;
        top: -2px;
        left: -2px;
        width: calc(100% + 4px);
        height: calc(100% + 4px);
        padding: 0 calc(4 / 146 * 100%);
        appearance: none;
        border: 1px solid #000;
        border-radius: 6px;
        background-color: #fff;
        &:disabled {
          color: currentColor;
        }
        .color_chip__container {
          position: relative;
          flex: 0 0 auto;
          flex-basis: calc(45 / 146 * 100%);
          border: 1px solid #000;
          border-radius: 6px;
          overflow: hidden;
          &::before {
            display: block;
            content: '';
            padding-top: calc(18 / 45 * 100%);
          }
          .color_chip {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
        .color_name {
          flex: 1 0 auto;
          flex-basis: 50%;
          margin-left: calc(4 / 146 * 100%);
          word-break: keep-all;
          line-break: strict;
          word-wrap: break-word;
          overflow-wrap: break-word;
          font-size: clamp(10px, 1.2vw, 18px);
          line-height: 1.2;
        }
      }
    }
  }
}
</style>
